import { SET_SHOP_INFORMATION } from '../types/shopInformation'

import { getShopInformationAPI, updateShopInformationAPI } from '../api/shopInformation'

import { addMessageCurry, commonActionAPIHit } from '../utils/api'

export const setShopInformation = (payload) => ({
  type: SET_SHOP_INFORMATION,
  payload,
})

export const getShopInformation = (groupName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getShopInformationAPI(groupName), dispatch).then((res) => {
        dispatch(setShopInformation(res))
        resolve(res)
      })
    })
  }
}

export const updateShopInformation = (data, groupName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateShopInformationAPI(data, groupName), dispatch).then((data) => {
        resolve(data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/shopInformation.js